// 账本基本字段
let tableData = [
  {
    label: '序号',
    type: 'index',
    align: 'center',
    show: true,
    width: 80
  },
  {
    label: '状态ID',
    prop: 'id',
    show: true,
    enableSlot: true,
    minWidth: 120

  },
  {
    label: '状态数据',
    prop: 'json',
    show: true,
    enableSlot: true,
    minWidth: 120
  },
  {
    label: '最新修改记录',
    prop: 'parentHash',
    show: true,
    enableSlot: true,
    minWidth: 120
  },
  {
    label: '状态版本',
    prop: 'statusVersion',
    align: 'center',
    show: true,
    width: 100
  },
  {
    prop: 'operators',
    label: '操作',
    fixed: 'right',
    align: 'right',
    width: 100,
    children: [
      {
        icon: 'el-icon-view',
        label: '查看',
        clickEvent: (thisVue, row) => {
          thisVue.handleDetail(row.id)
        },
        showFilter: () => {
          return true
        }
      }
    ]
  }
  // {
  //   label: '操作',
  //   prop: 'row',
  //   align: 'right',
  //   fixed: 'right',
  //   show: true,
  //   enableSlot: true,
  //   width: 100
  // }
]
let headData = {
  title: '状态列表'
}

let tableObj = {
  'tableData': tableData,
  'headData': headData
}

export default tableObj
